import { minVisitsAbbrFilter, percentageSignFilter, timeFilter } from "app/filters/ngFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { IBenchmarkVerticals } from "./types";
import { visitsFormatter, pagesPerVisitsFormatter } from "./utils";

const getChartTooltipTitle = (title: string) => ({
    Daily: title,
    Weekly: title,
    Monthly: title,
});

const { LAST_TWENTY_EIGHT_DAYS } = BasicDurations;

export const benchmarkVerticals: IBenchmarkVerticals = {
    Visits: {
        title: "segments.group.analysis.tab.visits.title",
        tooltipInfo: "segments.group.analysis.tab.visits.tooltip",
        dataKey: "Visits",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [visitsFormatter],
        name: "Visits",
        metricLabel: "Scale",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE, devicesTypes.TOTAL],
        chartTooltipTitle: {
            Daily: "segments.group.analysis.tab.visits.chart.tooltip.daily",
            Weekly: "segments.group.analysis.tab.visits.chart.tooltip.weekly",
            Monthly: "segments.group.analysis.tab.visits.chart.tooltip.monthly",
        },
    },
    TrafficShare: {
        title: "segments.group.analysis.tab.trafficshare.title",
        tooltipInfo: "segments.group.analysis.tab.trafficshare.tooltip",
        dataKey: "TrafficShare",
        filter: [percentageSignFilter, 1],
        name: "SegmentShare",
        metricLabel: "Efficiency",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.MOBILE, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.trafficshare.title"),
    },
    UniqueUsers: {
        title: "segments.group.analysis.tab.UniqueUsers.title",
        tooltipInfo: "segments.group.analysis.tab.UniqueUsers.tooltip",
        dataKey: "UniqueUsers",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [visitsFormatter],
        name: "UniqueUsers",
        metricLabel: "Scale",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.UniqueUsers.title"),
        get displayCustomAnnotation() {
            const isTotalWebsource = proNavigator.getParams().webSource === devicesTypes.TOTAL;
            return isTotalWebsource;
        },
        unsupportedDurations: [LAST_TWENTY_EIGHT_DAYS],
    },
    PagesViews: {
        title: "segments.group.analysis.tab.pageViews.title",
        tooltipInfo: "segments.group.analysis.tab.pageViews.tooltip",
        dataKey: "PagesViews",
        filter: [minVisitsAbbrFilter],
        yAxisFilter: [visitsFormatter],
        name: "PagesViews",
        metricLabel: "Scale",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.pageViews.title"),
    },
    PagePerVisit: {
        title: "segments.group.analysis.tab.pagePerVisit.title",
        tooltipInfo: "segments.group.analysis.tab.pagePerVisit.tooltip",
        dataKey: "PagePerVisit",
        filter: [pagesPerVisitsFormatter],
        name: "PagePerVisit",
        metricLabel: "Scale",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.pagePerVisit.title"),
    },
    VisitDuration: {
        title: "segments.group.analysis.tab.visitDuration.title",
        tooltipInfo: "segments.group.analysis.tab.visitDuration.tooltip",
        dataKey: "Duration",
        filter: [timeFilter],
        name: "VisitDuration",
        metricLabel: "Scale",
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.visitDuration.title"),
    },
    BounceRate: {
        title: "segments.group.analysis.tab.bounceRate.title",
        tooltipInfo: "segments.group.analysis.tab.bounceRate.tooltip",
        dataKey: "BounceRate",
        filter: [percentageSignFilter, 1],
        name: "BounceRate",
        metricLabel: "Efficiency",
        invertChange: true,
        supportedWebSources: [devicesTypes.DESKTOP, devicesTypes.TOTAL],
        chartTooltipTitle: getChartTooltipTitle("segments.group.analysis.tab.bounceRate.title"),
    },
};
